export const DEFAULT_SETTINGS = {
  thresholdLongSentenceLower: 5,
  thresholdLongSentenceUpper: 15,
  thresholdAvgSentenceLower: 12,
  thresholdAvgSentenceUpper: 18,
  thresholdPassiveVoiceLower: 4,
  thresholdPassiveVoiceUpper: 10,
  thresholdReadabilityLower: 30,
  thresholdReadabilityUpper: 50,
  thresholdLixReadabilityLower: 30,
  thresholdLixReadabilityUpper: 60,
  thresholdGradeLevelLower: 10,
  thresholdGradeLevelUpper: 20,
  longSentenceCutoff: 25,
  veryLongSentenceCutoff: 30,
  lixAlwaysEnabled: false,
};
